// extracted by mini-css-extract-plugin
export default {"about":"productsDetailAbout_about__nWFOG"};